import { BaseInvitePeopleAnalytics } from '../../analytics';
import { AnalyticsAction, AnalyticsActionSubject, type ProductSelectOption } from '../../types';

export class ProductSelectAnalytics extends BaseInvitePeopleAnalytics {
	productSelectRendered(productOptions: ProductSelectOption[]) {
		const { userRole, source } = this.commonAttributes;

		this.fireUI({
			actionSubject: AnalyticsActionSubject.DROPDOWN,
			actionSubjectId: 'customizedProductSelect',
			action: AnalyticsAction.RENDERED,
			attributes: {
				integration: source,
				source,
				userRole,
				productOptions,
			},
		});
	}

	selectAllClicked(productsSelected: string[]) {
		const { productTitle, source, userRole } = this.commonAttributes;

		this.fireUI({
			actionSubject: AnalyticsActionSubject.DROPDOWN_ITEM,
			action: AnalyticsAction.CLICKED,
			actionSubjectId: 'selectAll',
			attributes: {
				integration: source,
				source,
				product: productTitle.toLowerCase(),
				productsSelected,
				permissionLevel: userRole,
			},
		});
	}

	getAvailableProductsSucceeded(resourceAri: string, availableResourcesAri: string[]) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.INVITE_CAPABILITIES,
			actionSubjectId: resourceAri,
			action: AnalyticsAction.SUCCEEDED,
			attributes: {
				availableResourcesAri,
			},
		});
	}

	getAvailableProductsFailed(resourceAri: string) {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.INVITE_CAPABILITIES,
			actionSubjectId: resourceAri,
			action: AnalyticsAction.FAILED,
		});
	}
}
